import GMATScores from './GmatScores';
import GmatTag from './GmatTag';
import GREScores from './GreScores';
import GreTag from './GreTag';

const COMPETITIVE_TEST_SCORE_MAP = new Map<string, () => JSX.Element>();
COMPETITIVE_TEST_SCORE_MAP.set('GMAT', GMATScores);
COMPETITIVE_TEST_SCORE_MAP.set('GRE', GREScores);

const TAG_MAP = new Map<string, () => JSX.Element>();
TAG_MAP.set('GMAT', GmatTag);
TAG_MAP.set('GRE', GreTag);

const GmatScoreTag = () => {
  const Component = TAG_MAP.get('GMAT');

  return <>{Component ? <Component /> : null}</>;
};

const GreScoreTag = () => {
  const Component = TAG_MAP.get('GRE');

  return <>{Component ? <Component /> : null}</>;
};

export { GmatScoreTag, GreScoreTag };
